 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"albero_tag~configurazione~ristorazione_menu_composti~totem":"albero_tag~configurazione~ristorazione_menu_composti~totem","albero_tag":"albero_tag","configurazione":"configurazione","ristorazione_menu_composti":"ristorazione_menu_composti","articoli~bilance~buoniPasto~clienti~distintaBase~documenti~documentiEdit~eCommerce~esterni~fatturazi~1354bdf9":"articoli~bilance~buoniPasto~clienti~distintaBase~documenti~documentiEdit~eCommerce~esterni~fatturazi~1354bdf9","articoli~distintaBase":"articoli~distintaBase","distintaBase":"distintaBase","articoli~documenti~eCommerce~fatturazioneElettronica~lotti~movimenti~ordiniCliente~ordiniFornitore~park":"articoli~documenti~eCommerce~fatturazioneElettronica~lotti~movimenti~ordiniCliente~ordiniFornitore~park","articoli~eCommerce~import~importGenerico~inventario~tabacchi~totem":"articoli~eCommerce~import~importGenerico~inventario~tabacchi~totem","articoli":"articoli","autofattura~documenti~documentiEdit~ordiniCliente~ordiniFornitore":"autofattura~documenti~documentiEdit~ordiniCliente~ordiniFornitore","documenti~documentiEdit~ordiniCliente~ordiniFornitore~scalaTaglieProdotti":"documenti~documentiEdit~ordiniCliente~ordiniFornitore~scalaTaglieProdotti","documenti":"documenti","ordiniCliente":"ordiniCliente","fatturazioneElettronica":"fatturazioneElettronica","lotti":"lotti","movimenti":"movimenti","park":"park","totem":"totem","documentiEdit":"documentiEdit","bilance":"bilance","buoniPasto":"buoniPasto","cassaClientiDettaglio~clienti":"cassaClientiDettaglio~clienti","clienti":"clienti","eCommerce~exportDati~import~importGenerico~inventario~ordiniFornitore~scambioDati~stampe~tabacchi":"eCommerce~exportDati~import~importGenerico~inventario~ordiniFornitore~scambioDati~stampe~tabacchi","eCommerce":"eCommerce","tabacchi":"tabacchi","esterni":"esterni","lavorazioni":"lavorazioni","menuComposti":"menuComposti","offerte":"offerte","ristorazione_variazioni":"ristorazione_variazioni","varianti":"varianti","autofattura":"autofattura","benetton":"benetton","cassaClientiDettaglio":"cassaClientiDettaglio","cassaFattureElettroniche":"cassaFattureElettroniche","cassaHome":"cassaHome","dashboard":"dashboard","scalaTaglieProdotti":"scalaTaglieProdotti","ordiniFornitore":"ordiniFornitore","import":"import","importGenerico":"importGenerico","inventario":"inventario","exportDati":"exportDati","scambioDati":"scambioDati","stampe":"stampe","gestione_analisi":"gestione_analisi","gestione_flussi_ingresso":"gestione_flussi_ingresso","gestione_flussi_uscita":"gestione_flussi_uscita","gestione_personale":"gestione_personale","gestione_situazione":"gestione_situazione","importDati":"importDati","licenza":"licenza","login":"login","mobile_platform":"mobile_platform","numeratori":"numeratori","ottici":"ottici","pdf":"pdf","primaNota":"primaNota","scalaTaglieGestione":"scalaTaglieGestione","token":"token"}[chunkId]||chunkId) + "." + {"albero_tag~configurazione~ristorazione_menu_composti~totem":"fb388597","albero_tag":"7cfd5ef9","configurazione":"f9619e47","ristorazione_menu_composti":"8d392690","articoli~bilance~buoniPasto~clienti~distintaBase~documenti~documentiEdit~eCommerce~esterni~fatturazi~1354bdf9":"a20880ce","articoli~distintaBase":"6ad53cf4","distintaBase":"643e61df","articoli~documenti~eCommerce~fatturazioneElettronica~lotti~movimenti~ordiniCliente~ordiniFornitore~park":"49005b78","articoli~eCommerce~import~importGenerico~inventario~tabacchi~totem":"931cdc9c","articoli":"5a84169d","autofattura~documenti~documentiEdit~ordiniCliente~ordiniFornitore":"183b9c4d","documenti~documentiEdit~ordiniCliente~ordiniFornitore~scalaTaglieProdotti":"eb955e64","documenti":"93760927","ordiniCliente":"21a3f092","fatturazioneElettronica":"526f61f2","lotti":"31614612","movimenti":"03b56f26","park":"78c992c9","totem":"9472db64","documentiEdit":"0f48ec4a","bilance":"a20a3cf4","buoniPasto":"e0ee7264","cassaClientiDettaglio~clienti":"87ad387b","clienti":"4f9a68fd","eCommerce~exportDati~import~importGenerico~inventario~ordiniFornitore~scambioDati~stampe~tabacchi":"7e49c5e1","eCommerce":"a3cbe2f3","tabacchi":"ad8a7d8f","esterni":"2e161058","lavorazioni":"466bbb4a","menuComposti":"c5919b3a","offerte":"fc980d7d","ristorazione_variazioni":"3a5bab85","varianti":"1dad78a4","autofattura":"52304558","benetton":"a6a41c37","cassaClientiDettaglio":"e061c84c","cassaFattureElettroniche":"6593f590","cassaHome":"34d91834","dashboard":"6a058e84","scalaTaglieProdotti":"f7f84649","ordiniFornitore":"aa702f43","import":"ec5312f9","importGenerico":"4b203c80","inventario":"e252292c","exportDati":"f3ee5adf","scambioDati":"f6e7bf21","stampe":"b290de63","gestione_analisi":"ddb1779e","gestione_flussi_ingresso":"b0f1f863","gestione_flussi_uscita":"83c30f7e","gestione_personale":"7065c355","gestione_situazione":"5735dd68","importDati":"d7b9d5c8","licenza":"534d6ca7","login":"f427c5ad","mobile_platform":"9e435256","numeratori":"355fa4fa","ottici":"8b16963f","pdf":"e71b38b3","primaNota":"29d7c8b0","scalaTaglieGestione":"1d787526","token":"3b11b744"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"albero_tag~configurazione~ristorazione_menu_composti~totem":1,"configurazione":1,"ristorazione_menu_composti":1,"articoli~bilance~buoniPasto~clienti~distintaBase~documenti~documentiEdit~eCommerce~esterni~fatturazi~1354bdf9":1,"distintaBase":1,"articoli~documenti~eCommerce~fatturazioneElettronica~lotti~movimenti~ordiniCliente~ordiniFornitore~park":1,"articoli~eCommerce~import~importGenerico~inventario~tabacchi~totem":1,"articoli":1,"autofattura~documenti~documentiEdit~ordiniCliente~ordiniFornitore":1,"documenti~documentiEdit~ordiniCliente~ordiniFornitore~scalaTaglieProdotti":1,"documenti":1,"ordiniCliente":1,"fatturazioneElettronica":1,"lotti":1,"movimenti":1,"park":1,"totem":1,"documentiEdit":1,"bilance":1,"cassaClientiDettaglio~clienti":1,"clienti":1,"eCommerce":1,"tabacchi":1,"esterni":1,"lavorazioni":1,"menuComposti":1,"offerte":1,"ristorazione_variazioni":1,"varianti":1,"autofattura":1,"benetton":1,"dashboard":1,"ordiniFornitore":1,"import":1,"importGenerico":1,"inventario":1,"stampe":1,"gestione_flussi_ingresso":1,"licenza":1,"mobile_platform":1,"ottici":1,"pdf":1,"scalaTaglieGestione":1,"token":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"albero_tag~configurazione~ristorazione_menu_composti~totem":"albero_tag~configurazione~ristorazione_menu_composti~totem","albero_tag":"albero_tag","configurazione":"configurazione","ristorazione_menu_composti":"ristorazione_menu_composti","articoli~bilance~buoniPasto~clienti~distintaBase~documenti~documentiEdit~eCommerce~esterni~fatturazi~1354bdf9":"articoli~bilance~buoniPasto~clienti~distintaBase~documenti~documentiEdit~eCommerce~esterni~fatturazi~1354bdf9","articoli~distintaBase":"articoli~distintaBase","distintaBase":"distintaBase","articoli~documenti~eCommerce~fatturazioneElettronica~lotti~movimenti~ordiniCliente~ordiniFornitore~park":"articoli~documenti~eCommerce~fatturazioneElettronica~lotti~movimenti~ordiniCliente~ordiniFornitore~park","articoli~eCommerce~import~importGenerico~inventario~tabacchi~totem":"articoli~eCommerce~import~importGenerico~inventario~tabacchi~totem","articoli":"articoli","autofattura~documenti~documentiEdit~ordiniCliente~ordiniFornitore":"autofattura~documenti~documentiEdit~ordiniCliente~ordiniFornitore","documenti~documentiEdit~ordiniCliente~ordiniFornitore~scalaTaglieProdotti":"documenti~documentiEdit~ordiniCliente~ordiniFornitore~scalaTaglieProdotti","documenti":"documenti","ordiniCliente":"ordiniCliente","fatturazioneElettronica":"fatturazioneElettronica","lotti":"lotti","movimenti":"movimenti","park":"park","totem":"totem","documentiEdit":"documentiEdit","bilance":"bilance","buoniPasto":"buoniPasto","cassaClientiDettaglio~clienti":"cassaClientiDettaglio~clienti","clienti":"clienti","eCommerce~exportDati~import~importGenerico~inventario~ordiniFornitore~scambioDati~stampe~tabacchi":"eCommerce~exportDati~import~importGenerico~inventario~ordiniFornitore~scambioDati~stampe~tabacchi","eCommerce":"eCommerce","tabacchi":"tabacchi","esterni":"esterni","lavorazioni":"lavorazioni","menuComposti":"menuComposti","offerte":"offerte","ristorazione_variazioni":"ristorazione_variazioni","varianti":"varianti","autofattura":"autofattura","benetton":"benetton","cassaClientiDettaglio":"cassaClientiDettaglio","cassaFattureElettroniche":"cassaFattureElettroniche","cassaHome":"cassaHome","dashboard":"dashboard","scalaTaglieProdotti":"scalaTaglieProdotti","ordiniFornitore":"ordiniFornitore","import":"import","importGenerico":"importGenerico","inventario":"inventario","exportDati":"exportDati","scambioDati":"scambioDati","stampe":"stampe","gestione_analisi":"gestione_analisi","gestione_flussi_ingresso":"gestione_flussi_ingresso","gestione_flussi_uscita":"gestione_flussi_uscita","gestione_personale":"gestione_personale","gestione_situazione":"gestione_situazione","importDati":"importDati","licenza":"licenza","login":"login","mobile_platform":"mobile_platform","numeratori":"numeratori","ottici":"ottici","pdf":"pdf","primaNota":"primaNota","scalaTaglieGestione":"scalaTaglieGestione","token":"token"}[chunkId]||chunkId) + "." + {"albero_tag~configurazione~ristorazione_menu_composti~totem":"573a88ef","albero_tag":"31d6cfe0","configurazione":"df96a54d","ristorazione_menu_composti":"8dbeab1e","articoli~bilance~buoniPasto~clienti~distintaBase~documenti~documentiEdit~eCommerce~esterni~fatturazi~1354bdf9":"e79726c3","articoli~distintaBase":"31d6cfe0","distintaBase":"0a924653","articoli~documenti~eCommerce~fatturazioneElettronica~lotti~movimenti~ordiniCliente~ordiniFornitore~park":"8dd7432e","articoli~eCommerce~import~importGenerico~inventario~tabacchi~totem":"df96a54d","articoli":"9def774a","autofattura~documenti~documentiEdit~ordiniCliente~ordiniFornitore":"22c5f388","documenti~documentiEdit~ordiniCliente~ordiniFornitore~scalaTaglieProdotti":"937b756d","documenti":"f855864a","ordiniCliente":"f855864a","fatturazioneElettronica":"f07d63c4","lotti":"380e1dac","movimenti":"9d7a4131","park":"03e26277","totem":"4ab9d3dd","documentiEdit":"cc21a525","bilance":"764eda30","buoniPasto":"31d6cfe0","cassaClientiDettaglio~clienti":"8086d185","clienti":"218667ae","eCommerce~exportDati~import~importGenerico~inventario~ordiniFornitore~scambioDati~stampe~tabacchi":"31d6cfe0","eCommerce":"8445ce4c","tabacchi":"1287cbe8","esterni":"25d9c06d","lavorazioni":"9b01c8ec","menuComposti":"292042d2","offerte":"2374fc0e","ristorazione_variazioni":"e89f3967","varianti":"9d3c6ea5","autofattura":"6161da7c","benetton":"76a811a3","cassaClientiDettaglio":"31d6cfe0","cassaFattureElettroniche":"31d6cfe0","cassaHome":"31d6cfe0","dashboard":"604a187c","scalaTaglieProdotti":"31d6cfe0","ordiniFornitore":"cfbac791","import":"4c73043d","importGenerico":"4c73043d","inventario":"9e7979a6","exportDati":"31d6cfe0","scambioDati":"31d6cfe0","stampe":"33f0f7a1","gestione_analisi":"31d6cfe0","gestione_flussi_ingresso":"63c64413","gestione_flussi_uscita":"31d6cfe0","gestione_personale":"31d6cfe0","gestione_situazione":"31d6cfe0","importDati":"31d6cfe0","licenza":"8e40865e","login":"31d6cfe0","mobile_platform":"02bfcb85","numeratori":"31d6cfe0","ottici":"06124ba0","pdf":"31d9adac","primaNota":"31d6cfe0","scalaTaglieGestione":"a8c8cd93","token":"0d238917"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
